import {
    SET_SELECTED_OPTIONS,
    SET_OFFICE_NETWORK_COMMENTS
} from "../actions/officeNetworkAction";

const initialState = {
    selectedOptions: [],
    isOptionSelected: false,
    comments: "",
};

const officeNetworkReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_OPTIONS:
            return {
                ...state,
                selectedOptions: action.payload,
                isOptionSelected: action.payload.length > 0,
            };
        case SET_OFFICE_NETWORK_COMMENTS:
            return {
                ...state,
                comments: action.payload,
            };
        default:
            return state;
    }
};

export default officeNetworkReducer;
